export default `<svg viewBox="0 0 511.713 432.621" preserveAspectRatio="xMinYMid" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
 <g>
    <path d="M466.891,281.448H44.822c-5.835,0-10.552,4.717-10.552,10.552s4.717,10.552,10.552,10.552h422.068
      c5.835,0,10.552-4.717,10.552-10.552S472.726,281.448,466.891,281.448z"/>
    <path d="M44.822,239.241h94.966c5.835,0,10.552-4.717,10.552-10.552c0-58.182,47.335-105.517,105.517-105.517
      c58.183,0,105.518,47.335,105.518,105.517c0,5.835,4.716,10.552,10.552,10.552h94.965c5.835,0,10.552-4.717,10.552-10.552
      s-4.717-10.552-10.552-10.552h-84.951c-5.393-64.893-59.818-116.068-126.083-116.068s-120.69,51.176-126.082,116.068H44.822
      c-5.835,0-10.552,4.717-10.552,10.552S38.987,239.241,44.822,239.241z"/>
  </g>
</svg>`